import { VideoService } from './../services/video.service';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from '../services/user.service';
import { createUrlResolverWithoutPackagePrefix } from '@angular/compiler';


@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.css']
})
export class MenuComponent implements OnInit {
  user;
  public categories = [];

  constructor(
    private router: Router,
    private userService: UserService,
    private videoService: VideoService  
    ) { 
    document.body.style.backgroundColor = "#fff"
  }

  ngOnInit() {
    this.videoService.getVideoList();
    this.user = JSON.parse(localStorage.getItem('user'));
    this.userService.getPriceListConfig(this.user.session_token).then((priceList)=>{
      localStorage.setItem('priceList',JSON.stringify(priceList));
    });
    this.categories = JSON.parse(localStorage.getItem('videoList'));
    console.log("categories", this.categories);
  }


  logoutUser() {
    console.log("try to logout");
    let user = JSON.parse(localStorage.getItem('user'));
    if (user) {
      let token = user.session_token
      this.userService.logout(token).then(() => {
        localStorage.removeItem('user');
        this.router.navigate(['login-page']);

      }, (err) => {
        console.log(err)
        localStorage.removeItem('user');
        this.router.navigate(['login-page']);
      });
    } else {
      console.log('no User found')
      localStorage.removeItem('user');
      this.router.navigate(['login-page']);

    }
  }

}



// WEBPACK FOOTER //
// ./src/app/menu/menu.component.ts